module.exports = __webpack_public_path__ + "img/8.de4d34c8.png";